import { render, staticRenderFns } from "./CreateLayout.vue?vue&type=template&id=6ae1d52e&scoped=true"
import script from "./CreateLayout.vue?vue&type=script&lang=ts"
export * from "./CreateLayout.vue?vue&type=script&lang=ts"
import style0 from "./CreateLayout.vue?vue&type=style&index=0&id=6ae1d52e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae1d52e",
  null
  
)

export default component.exports